// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__EqQer","inputWrap":"CustomTip_inputWrap__RyMGC"};